import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import InputText from "../../components/forms/elements/InputText";
import CategoriaBaixaService from "../../services/CategoriaBaixaService";
import CrudForm from "../../components/forms/custom/CrudForm";

class FormCategoriaBaixa extends CrudForm {

    constructor(props) {
        super(props);

        this.state.model = {
            idCategoriaBaixa: "",
            nome: ""
        };

        this.state.crud = {
            service: CategoriaBaixaService,
            labels: {
                title: 'Categoria Baixa',
            },
            urlList: '/LstCategoriaBaixa',
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderFields() {
        return (
            <div className="row mb-3 g-3">
                <InputText label="Código" md={3} value={this.state.model.idCategoriaBaixa} name="idCategoriaBaixa" readOnly opcionalLabel={false}/>
                <InputText label="Nome do Categoria Baixa" autoFocus={true} required md={9} value={this.state.model.nome} name="nome" onChange={this.handleChange} maxLength={100} />
            </div>
        );
    }

    render() {
        return super.render();
    }
}

function With(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <FormCategoriaBaixa {...props} navigate={navigate} params={params} />
}

export default With